import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';

Vue.use(abilitiesPlugin);
